import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { WHATS_NEW_ITEMS, WHATS_NEW_TITLE, PANEL_KEY } from '../content/whatsNew';
import { useVoidNew } from '../hooks/useVoidNew';
import './WhatsNew.css';

export function WhatsNew() {
  const { isNew } = useVoidNew();
  const [open, setOpen] = useState(() => localStorage.getItem(PANEL_KEY) !== 'false');

  const toggle = () => {
    const next = !open;
    setOpen(next);
    localStorage.setItem(PANEL_KEY, String(next));
  };

  const anyNew = WHATS_NEW_ITEMS.some((i) => isNew(i.path));

  return (
    <div className={`whats-new-panel${open ? ' whats-new-panel--open' : ''}`}>
      <button className="whats-new-panel__toggle" onClick={toggle} aria-expanded={open}>
        <span className="whats-new-panel__title">
          {WHATS_NEW_TITLE}
          {anyNew && <span className="new-star">*</span>}
        </span>
        {open ? <ChevronUp size={11} /> : <ChevronDown size={11} />}
      </button>

      {open && (
        <ul className="whats-new-panel__list">
          {WHATS_NEW_ITEMS.map((item) => (
            <li key={item.path}>
              <Link to={item.path} className="whats-new-panel__link">
                <span className="whats-new-panel__label">{item.label}</span>
                <span className="whats-new-panel__desc">{item.description}</span>
                {isNew(item.path) && <span className="new-star">*</span>}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
